import { visserApi } from './visserApi';
import { convertModelToFormData } from './helpers';
const getOrderNumber = async () => {
    return await visserApi.get('Order/GetOrderNumber');
};
const createOrder = async (createdOrder) => {
    return await visserApi.post('Order/Create', createdOrder);
};
const getOrderById = (orderId) => {
    return visserApi.get(`Order/GetOrderById/${orderId}`);
};
const getAllCreditors = async () => {
    return await visserApi.get('Creditor/GetAll');
};
const getContactPersonsById = (debtorId) => {
    return visserApi.get(`debtor/GetContactPersonsByDebitorId/${debtorId}`);
};
const getWorkOrdersListWithClientAsync = async (workOrderNumber) => {
    return await visserApi.get(`Workorder/GetSearchableWorkOrdersList/${workOrderNumber}`);
};
const getAllOrderStatus = async () => {
    return await visserApi.get('Order/GetAllOrderStatus');
};
const updateOrder = async (orderId, updateOrderDto) => {
    return await visserApi.put(`Order/Update/${orderId}`, updateOrderDto);
};
const getAllOrder = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`Order/GetAll?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const getAllProgressNotesByOrderId = (orderId) => {
    return visserApi.get(`Order/GetAllOrderNotesByOrderId/${orderId}`);
};
const saveProgressNotesById = (createOrderNotesDto) => {
    return visserApi.post('Order/SaveOrderNotesByOrderId', createOrderNotesDto);
};
const deleteProgressNotesById = (progressnote) => {
    return visserApi.post('Order/DeleteOrderNotesById?id', progressnote);
};
const getAllAttachmentsByOrderId = async (orderId) => {
    return await visserApi.get(`Order/GetAllAttachmentsByOrderId/${orderId}`);
};
const addAttachmentsByOrderId = (fileUploaded) => {
    const formData = convertModelToFormData(fileUploaded);
    return visserApi.postForm('Order/UploadOrderAttachment', formData);
};
const deleteOrderAttachment = (attachmentId) => {
    return visserApi.delete(`Order/DeleteOrderAttachmentById/${attachmentId}`);
};
const deleteOrderById = async (id) => {
    return await visserApi.delete(`Order/Delete/${id}`);
};
const generatePriceRequestPdf = async (generatePriceRequestPdfDto) => {
    const response = await visserApi.post(`Order/GeneratePriceRequestPdf`, generatePriceRequestPdfDto);
    return response.data;
};
const generateOrderPdf = async (generateOrderPdfDto) => {
    const response = await visserApi.post(`Order/GenerateOrderPdf`, generateOrderPdfDto);
    return response.data;
};
const updateOrderStatusById = async (updateOrderStatus) => {
    return await visserApi.put(`Order/UpdateOrderStatusById`, updateOrderStatus);
};
const generateOrderPdfAsAttachment = async (generateOrderPdfDto) => {
    const response = await visserApi.post(`Order/generateOrderPdfAsAttachment`, generateOrderPdfDto);
    return response.data;
};
const generatePriceRequestPdfAsAttachment = async (generatePriceRequestPdfDto) => {
    const response = await visserApi.post(`Order/GeneratePriceRequestPdfAsAttachment`, generatePriceRequestPdfDto);
    return response.data;
};
const OrderApi = {
    getOrderNumber,
    createOrder,
    getOrderById,
    getAllCreditors,
    getContactPersonsById,
    getWorkOrdersListWithClientAsync,
    getAllOrderStatus,
    updateOrder,
    getAllOrder,
    getAllProgressNotesByOrderId,
    saveProgressNotesById,
    deleteProgressNotesById,
    getAllAttachmentsByOrderId,
    addAttachmentsByOrderId,
    deleteOrderAttachment,
    deleteOrderById,
    generatePriceRequestPdf,
    generateOrderPdf,
    updateOrderStatusById,
    generateOrderPdfAsAttachment,
    generatePriceRequestPdfAsAttachment
};
export default OrderApi;
